import getBase64ImageSize from './getBase64ImageSize';

export default (inputImage, maxWidth, maxHeight) => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onerror = () => {
      reject();
    };

    image.onload = () => {
      const ratioWidth = Math.min(1, maxWidth / image.width);
      const ratioHeight = Math.min(1, maxHeight / image.height);
      const ratio = Math.min(ratioWidth, ratioHeight);

      console.log('Transformation');
      console.log(`Proportions=(${ image.width }, ${ image.height }) ratio=${ ratio.toFixed(2) }%`);

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = image.width * ratio;
      canvas.height = image.height * ratio;

      ctx.drawImage(image,
        0, 0, image.width, image.height,
        0, 0, canvas.width, canvas.height,
      );
      const nextImage = new Image();
      nextImage.src = canvas.toDataURL();

      const convertedBase64 = `${ (getBase64ImageSize(nextImage.src) / 1000).toFixed(1) } kb`;
      const originalBase64 = `${ (getBase64ImageSize(inputImage) / 1000).toFixed(1) } kb`;

      const enhancedMeta = {
        originalSize: originalBase64,
        reducedSize: convertedBase64,
      };

      console.log('Converted base64:', convertedBase64);
      console.log('Original base64:', originalBase64);

      resolve({ logo: nextImage.src, meta: enhancedMeta });
    };

    image.src = inputImage;
  });
};
